import { ActionTypes } from '../actions';

const initialState = {
  all: [],
};

const UserPagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PAGES_BY_USER:
      return { all: action.payload };
    default:
      return state;
  }
};

export default UserPagesReducer;
